export const CMS_PROTOCOL_TOKEN = 'CMS_LOG';